export default __webpack_public_path__ + "static/media/ijm_logo2.15b90945.png";